import { useEffect } from "react";
import { useRef } from "react"

const useClickOutside = (handler) => {
    let domNode = useRef()
    useEffect(() => {
        const event = document.addEventListener('mousedown', (event) => {
            if (!domNode.current?.contains(event.target)) {
                handler();
            }
        });

        return () => document.removeEventListener('mousedown', event)
    })
    return domNode
}

export default useClickOutside;